import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';
import { GuidancePatternEntity } from './GuidancePattern';

export class GuidanceGroupEntity implements Entity {
  public static fromXML(xml) {
    const attrs = xml._attributes;
    const isoId = attrs[ATTRS.GuidanceGroup.GuidanceGroupId];
    // const id = matchIDs[isoId] ? matchIDs[isoId].id : null

    const guidancePatterns = (xml[TAGS.GuidancePattern] || []).map(
      (xml) => GuidancePatternEntity.fromXML(xml).entity
    );

    return {
      entity: new GuidanceGroupEntity(
        isoId,
        attrs[ATTRS.GuidanceGroup.GuidanceGroupDesignator],
        guidancePatterns
      ),
      isoId,
    };
  }

  public type = TAGS.GuidanceGroup;
  public id: string;

  constructor(
    id: string,
    public designator: string,
    public guidancePatterns?: GuidancePatternEntity[]
  ) {
    this.id = id;
  }

  public toXML() {
    const guidancePatternEntities = (this.guidancePatterns || []).map((guidancePattern) =>
      guidancePattern.toXML()
    );

    return {
      _attributes: {
        [ATTRS.GuidanceGroup.GuidanceGroupId]: this.id,
        [ATTRS.GuidanceGroup.GuidanceGroupDesignator]: this.designator,
      },
      [TAGS.GuidancePattern]: guidancePatternEntities,
    };
  }
}
